export default "__VITE_ASSET__81bafe86__"